import { IErrorResponseType } from "../../constants/commonTypes";

export const GET_IB_AUTHENTICATION = "GET_IB_AUTHENTICATION"
export const GET_IB_AUTHENTICATION_REQUEST = "GET_IB_AUTHENTICATION_REQUEST"
export const GET_IB_AUTHENTICATION_FAILURE = "GET_IB_AUTHENTICATION_FAILURE"
export const GET_IB_AUTHENTICATION_ERROR = "GET_IB_AUTHENTICATION_ERROR"
export const GET_IB_AUTHENTICATION_SUCCESS = "GET_IB_AUTHENTICATION_SUCCESS"


export interface GetIBAuthenticationAction {
  type: typeof GET_IB_AUTHENTICATION;
  request: object;
}

export interface GetIBAuthenticationRequestAction {
  type: typeof GET_IB_AUTHENTICATION_REQUEST;
}

export interface GetIBAuthenticationSuccessAction {
  type: typeof GET_IB_AUTHENTICATION_SUCCESS;
  authResponse: boolean;
  partnerId: string;
  partnerName: string;
  resumeJourneyEligibility: boolean;
  originalTxnId: string;
  customerId: string;
}

export interface GetIBAuthenticationFailureAction {
  type: typeof GET_IB_AUTHENTICATION_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export interface GetIBAuthenticationErrorAction {
  type: typeof GET_IB_AUTHENTICATION_ERROR;
}

export type AuthActions =
  | GetIBAuthenticationAction
  | GetIBAuthenticationRequestAction
  | GetIBAuthenticationSuccessAction
  | GetIBAuthenticationFailureAction
  | GetIBAuthenticationErrorAction;